import { FormEvent, useCallback, useState } from 'react'

import { Button, Input, PasswordInput, Stack, TextInput } from '@mantine/core'
import { useLogin, useNotify, useTranslate } from 'react-admin'

import { Link } from '@mui/material'
import { LoginLayout } from './LoginLayout'

export const Login = () => {
  const login = useLogin()
  const notify = useNotify()
  const t = useTranslate()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const onLogin = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      setIsLoading(true)

      try {
        await login({ email, password }, '/analytics')
        setIsLoading(false)
      } catch (error) {
        notify('Invalid email or password')
        console.error(error)
        setIsLoading(false)
      }
    },
    [login, email, password, notify],
  )

  return (
    <LoginLayout title="Login">
      <form onSubmit={onLogin}>
        <Stack w={300} p="md" pt="xs" pb="md">
          <Input.Wrapper label={t('_generics.id')} id="email">
            <TextInput
              id="email"
              name="email"
              type="email"
              size="md"
              value={email}
              onChange={e => setEmail(e.currentTarget.value)}
            />
          </Input.Wrapper>
          <Stack gap={4}>
            <Input.Wrapper label={t('_generics.password')} id="password">
              <PasswordInput
                id="password"
                name="password"
                type="password"
                size="md"
                value={password}
                onChange={e => setPassword(e.currentTarget.value)}
              />
            </Input.Wrapper>
            <Link href="/reset-password" fontSize={12}>
              {t('pages.login.forgotPassword')}
            </Link>
          </Stack>
          <Button type="submit" mt="md" size="md" loading={isLoading}>
            {t('pages.login._title')}
          </Button>
        </Stack>
      </form>
    </LoginLayout>
  )
}
